import { Component, OnInit, ViewChild } from '@angular/core'
import { PrimeNGConfig } from 'primeng/api'
import { ErrorPopupComponent } from './carefinity/popups/errorpopup.component'
import { ErrorService } from './carefinity/services/ErrorService'
import { Subscription } from 'rxjs'
import { AppSettingService } from './api/services'
import { CareFinitySession } from './carefinity/services/CareFinitySession'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  topbarTheme = 'lightgreen'

  menuTheme = 'bluegrey'

  layoutMode = 'light'

  menuMode = 'static'

  inlineMenuPosition = 'bottom'

  inputStyle = 'filled'
  // componentTheme = 'lime';
  theme = 'green'
  ripple = true

  isRTL = false
  themeStyle: {
    scale?: number
    layoutMode?: string
    menuMode?: string
    inlineMenuPosition?: string
    inputBackground?: string
    rippleEffect?: boolean
    rtl?: boolean
    menuTheme?: string
    topbarTheme?: string
    componentTheme?: string
    inputStyle?: string
    theme?: string
  } = {}
  constructor(
    private primengConfig: PrimeNGConfig,
    private errorService: ErrorService,
    private appSettingService: AppSettingService,
  ) {}

  @ViewChild('errorPopup') errorPopup: ErrorPopupComponent

  ngOnInit() {
    this.appSettingService
      .appSettingGetApplicationSettings$Response()
      .subscribe({
        next: (setings) => {
          CareFinitySession.loadAppSettings(setings.body)
        },
        error: (err) => {
          console.error(err)
        },
      })
    this.primengConfig.ripple = true
    this.setTheme()
  }
  errorSub: Subscription
  ngAfterViewInit() {
    this.errorSub = this.errorService.error$.subscribe((message) => {
      this.errorPopup.show(message)
    })
  }

  closeAnyErros() {
    this.errorPopup.close()
  }

  private setTheme() {
    if (localStorage.getItem('themeStyle')) {
      try {
        JSON.parse(localStorage.getItem('themeStyle'))

        this.themeStyle = JSON.parse(localStorage.getItem('themeStyle'))

        this.topbarTheme = this.themeStyle.topbarTheme || this.topbarTheme

        this.menuTheme = this.themeStyle.menuTheme || this.menuTheme

        this.layoutMode = this.themeStyle.layoutMode || this.layoutMode

        this.menuMode = this.themeStyle.menuMode || this.menuMode

        this.inlineMenuPosition =
          this.themeStyle.inlineMenuPosition || this.inlineMenuPosition

        this.inputStyle = this.themeStyle.inputStyle || this.inputStyle

        this.ripple = this.themeStyle.rippleEffect || this.ripple

        this.isRTL = this.themeStyle.rtl || this.isRTL

        this.theme = this.themeStyle.theme || this.theme
      } catch (e) {
        console.error(e)
      }
    } else {
      this.layoutMode = 'light'
      this.menuTheme = 'light'
      this.topbarTheme = 'blue'
      this.inputStyle = 'outlined'
    }
  }

  ngOnDestroy() {
    console.log('app.ngOnDestroy')
    this.errorSub.unsubscribe()
  }
}
